import { Component, OnInit } from '@angular/core';
import { OrderService } from '../order.service';
import { ActivatedRoute } from '@angular/router';
import { IOrder } from '@redirector-service/shared';
import { MetaDataService } from '../metadata.service';

@Component({
  selector: 'tea-shop-fe-order',
  standalone: false,
  
  templateUrl: './order.component.html',
  styleUrl: './order.component.css'
})
export class OrderComponent implements OnInit {

  order?: IOrder;
  loading = true;
  error?: string;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private metaDataService: MetaDataService,
  ) { 
    this.metaDataService.updateMetadata({
      title: 'Sencha Steep in Transit - Order Status',
      image: '/assets/contact/sencha-logo.png',
    });
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const orderId = params.get('orderId');
      if (!orderId) {
        this.error = 'Order ID not found';
        this.loading = false;
        return;
      }

      this.orderService.getOrder(orderId).subscribe({
        next: (order) => {
          this.order = order;
          this.loading = false;
        },
        error: (err) => {
          this.error = 'Failed to load order';
          this.loading = false;
        }
      });
    });
  }

  getStatusStyle(status: string): string {
    const baseClasses = 'px-3 py-1 rounded-full text-sm font-medium';
    switch (status.toLowerCase()) {
      case 'pending':
      case 'created':
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case 'processing':
      case 'in transit':
        return `${baseClasses} bg-blue-100 text-blue-800`;
      case 'completed':
      case 'delivered':
        return `${baseClasses} bg-green-100 text-green-800`;
      case 'cancelled':
        return `${baseClasses} bg-red-100 text-red-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  }
}
